<template>
    <div class="login px-1 bg-light pt-5">
        <div class="mx-auto px-4 kovatek-login border shadow-lg pt-2 bg-white mb-5">
            <form class="py-3 px-md-2 mx-auto" @submit="loginHandler($event)">
                <div class="">
                    <a href="https://beta.kovatek.com">
                        <img class="navbar-brand logo-size my-4 " src="/images/logo.png" alt="Kovatek" />
                    </a>

                    <div class="alert alert-success" v-if="message">
                        <strong>{{ message }}</strong>
                    </div>
                    <p class="text-danger font-weight-bolder" v-if="error">{{ error }}</p>
                    <!-- <h4 class="font-weight-bolder mb-3">Login</h4> -->
                    <!-- <div class="m-auto">
                                <button class="btn add-grey shadow-sm py-3 w-100 mt-2 mb-3">
                                    <font-awesome-icon :icon="['fab', 'github']" class="mx-2 icon-size" />Login with Github</button>
                            </div> -->
                    <!-- <a-divider class="m-0 p-0">OR</a-divider> -->
                    <div class="my-3">
                        <input
                            type="email"
                            class="form-control input-height"
                            id="email"
                            placeholder="Email Address"
                            :disabled="loading"
                            v-model="email"
                            required
                        />
                    </div>
                    <div class="mb-3" style="position: relative">
                        <input
                            :type="showPassword ? 'text' : 'password'"
                            class="form-control input-height"
                            id="pwd"
                            :disabled="loading"
                            placeholder="Password"
                            v-model="password"
                            required
                        />
                        <span @click="showPassword = !showPassword" class="show-pass">
                            {{ showPassword ? 'Hide' : 'Show' }}
                        </span>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col">
                        <label class="checkbox-label mb-3">
                            <input type="checkbox" value="remember" :disabled="loading" v-model="rememberMe" />
                            <span class="checkbox-custom rectangular"></span
                            ><span class="mb-3 input-title float-left">Remember me</span>
                        </label>
                    </div>
                    <div class="col text-right">
                        <router-link to="/forgot_password" class="font-weight-bold kova-text">
                            <span class="underline"
                                ><font-awesome-icon icon="lock" size=""></font-awesome-icon
                                ><u class="ml-2"><a>Lost password?</a></u></span
                            >
                        </router-link>
                    </div>
                </div>
                <div class="m-auto">
                    <button class="btn btn-kovatek mt-3 w-100 mb-4" :disabled="loading" type="submit">
                        Login
                    </button>
                </div>
                <!-- <a-divider /> -->
                <p>
                    New to kovatek?
                    <router-link to="/register" class="font-weight-bold kova-text"
                        ><a>Create an account</a></router-link
                    >
                </p>
                <!-- <p>Haven't verify account? <router-link to="/token" class="font-weight-bold kova-text"><a>Request verification email</a></router-link> </p> -->
            </form>
        </div>
        <!-- </div> -->
        <Footers />
    </div>
</template>
<script>
import Footers from '@/components/Footer.vue';
export default {
    name: 'login',
    components: {
        Footers,
    },
    data() {
        return {
            email: '',
            password: '',
            rememberMe: null,
            message: '',
            loading: false,
            error: null,
            showPassword: false,
        };
    },
    computed: {
        isLoggedIn: () => {
            return this.$store.getters.isLoggedIn;
        },
    },
    methods: {
        loginHandler(event) {
            event.preventDefault();
            this.error = null;
            const { email, password } = this;
            const isValid = email === '' || password === '';

            if (!isValid) {
                const data = {
                    email,
                    password,
                    user_type: 1,
                };
                // console.log(data)

                this.loading = true;
                this.$store
                    .dispatch('login', data)
                    .then(resp => {
                        if (resp.data) {
                            this.message = 'Login Successful';
                            this.$router.push('/profile');
                        }
                    })
                    .catch(err => {
                        this.loading = false;
                        if (!err.response)
                            return (this.error = 'A network error occured, please check your internet connection');
                        this.error =
                            err.response.data == 'data: resource not found'
                                ? 'User does not exist'
                                : 'invalid email or password';
                    });
            } else {
                this.error = 'Invalid inputs';
            }
        },
    },
};
</script>
<style scoped>
.input-title {
    margin-left: 25px;
    font-size: 13px;
}

.logo-size {
    height: 45px;
    width: 150px;
}

.kovatek-login {
    width: 600px;
}
.add-grey {
    background-color: #ddd;
}
.add-grey:hover {
    background-color: #ccc;
}
.input-height {
    height: 50px;
    font-size: 13px;
    width: 100%;
}

.btn-kovatek {
    background-color: #20409a;
    height: 50px;
    color: #fff;
    transition: 0.25s;
}
.btn-kovatek:hover {
    background-color: #06216d;
    color: #fff;
}
.icon-size {
    font-size: 20px;
}

.show-pass {
    color: #06216d;
    position: absolute;
    top: 15px;
    right: 15px;
    z-index: 99;
    cursor: pointer;
}

@media (min-width: 768px) and (max-width: 991px) {
}
@media (max-width: 767px) {
    .kovatek-login {
        width: 400px;
    }
    .input-height {
        font-size: 16px;
    }
}

@media (max-width: 450px) {
    .kovatek-login {
        width: 100%;
    }
}
</style>
